var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"gd-type",class:`gd-type-${_vm.type}`},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }